import React from "react";

const EVENT_TYPES = [
  { kind: "class", label: "Classes" },
  { kind: "pt", label: "PT Sessions" },
  { kind: "facility", label: "Facilities" },
];

const CheckIcon = ({ checked }) => (
  <img
    src={
      checked
        ? "/img/svg/vuesax-linear-tick-square-checked.svg"
        : "/img/new-icons/unchecked-square.svg"
    }
    alt=""
    className={
      checked
        ? "scheduling-sidebar-filter-check-icon is-checked"
        : "scheduling-sidebar-filter-check-icon"
    }
  />
);

const SchedulingSidebarFilters = ({
  eventsByKind,
  coaches,
  filterKinds,
  filterEventIds,
  filterCoachIds,
  setFilterKinds,
  setFilterEventIds,
  setFilterCoachIds,
  defaultCoachId = "",
  hasNonPullScheduling = true,
}) => {
  const [expandedKinds, setExpandedKinds] = React.useState(() => new Set());

  const toggleKind = (kind) =>
    setFilterKinds((prev) => {
      const n = new Set(prev);
      n.has(kind) ? n.delete(kind) : n.add(kind);
      return n;
    });
  const toggleEvent = (id) =>
    setFilterEventIds((prev) => {
      const n = new Set(prev);
      n.has(id) ? n.delete(id) : n.add(id);
      return n;
    });
  const toggleCoach = (id) =>
    setFilterCoachIds((prev) => {
      const n = new Set(prev);
      n.has(id) ? n.delete(id) : n.add(id);
      return n;
    });

  const toggleExpand = (kind) =>
    setExpandedKinds((prev) => {
      const n = new Set(prev);
      n.has(kind) ? n.delete(kind) : n.add(kind);
      return n;
    });

  const selectAllCoaches = () => {
    setFilterCoachIds(new Set(coaches.map((c) => c.id)));
  };

  const resetFilters = () => {
    setFilterKinds(new Set());
    setFilterEventIds(new Set());
    setFilterCoachIds(defaultCoachId ? new Set([defaultCoachId]) : new Set());
  };

  // Facilities are hidden when only PULL scheduling is enabled.
  const visibleEventTypes = hasNonPullScheduling
    ? EVENT_TYPES
    : EVENT_TYPES.filter(({ kind }) => kind !== "facility");

  return (
    <div className="scheduling-sidebar-filters-inner">
      <h2 className="scheduling-sidebar-filters-title">Filters</h2>

      <section className="scheduling-sidebar-filter-section">
        <h3 className="scheduling-sidebar-filter-section-label">Event Types</h3>

        <ul className="scheduling-sidebar-filter-list">
          {visibleEventTypes.map(({ kind, label }) => {
            const subEvents = eventsByKind?.[kind] ?? [];
            const isExpanded = expandedKinds.has(kind);
            return (
              <li key={kind} className="scheduling-sidebar-filter-item">
                <div className="scheduling-sidebar-filter-row">
                  {subEvents.length > 0 ? (
                    <button
                      type="button"
                      className="scheduling-sidebar-filter-chevron"
                      onClick={() => toggleExpand(kind)}
                      aria-label={isExpanded ? "Collapse" : "Expand"}
                    >
                      <img
                        src={
                          isExpanded
                            ? "/img/new-icons/vuesax-linear-arrow-square-down.svg"
                            : "/img/new-icons/vuesax-linear-arrow-square-right.svg"
                        }
                        alt=""
                      />
                    </button>
                  ) : (
                    <span className="scheduling-sidebar-filter-chevron-spacer" />
                  )}
                  <label className="scheduling-sidebar-filter-check-row">
                    <input
                      type="checkbox"
                      className="scheduling-sidebar-filter-checkbox"
                      checked={filterKinds.has(kind)}
                      onChange={() => toggleKind(kind)}
                    />
                    <CheckIcon checked={filterKinds.has(kind)} />
                    <span className="scheduling-sidebar-filter-label scheduling-sidebar-filter-label--category">
                      {label}
                    </span>
                  </label>
                </div>

                {isExpanded && subEvents.length > 0 && (
                  <ul className="scheduling-sidebar-filter-sublist">
                    {subEvents.map((ev) => (
                      <li
                        key={ev.id}
                        className="scheduling-sidebar-filter-subitem"
                      >
                        <label className="scheduling-sidebar-filter-check-row">
                          <input
                            type="checkbox"
                            className="scheduling-sidebar-filter-checkbox"
                            checked={filterEventIds.has(ev.id)}
                            onChange={() => toggleEvent(ev.id)}
                          />
                          <CheckIcon checked={filterEventIds.has(ev.id)} />
                          <span className="scheduling-sidebar-filter-label scheduling-sidebar-filter-label--sub">
                            {ev.title}
                          </span>
                        </label>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </section>

      {coaches.length > 0 && (
        <section className="scheduling-sidebar-filter-section">
          <div className="scheduling-sidebar-filter-coach-header">
            <h3 className="scheduling-sidebar-filter-section-label">Coach</h3>
            <button
              type="button"
              className="scheduling-sidebar-filter-select-all"
              onClick={selectAllCoaches}
            >
              Select all
            </button>
          </div>

          <ul className="scheduling-sidebar-filter-list">
            {coaches.map((c) => (
              <li
                key={c.id}
                className="scheduling-sidebar-filter-item scheduling-sidebar-filter-item--coach"
              >
                <div className="scheduling-sidebar-filter-row">
                  <label className="scheduling-sidebar-filter-check-row">
                    <input
                      type="checkbox"
                      className="scheduling-sidebar-filter-checkbox"
                      checked={filterCoachIds.has(c.id)}
                      onChange={() => toggleCoach(c.id)}
                    />
                    <CheckIcon checked={filterCoachIds.has(c.id)} />
                    <img
                      src={c.avatarUrl}
                      alt=""
                      className="scheduling-sidebar-filter-coach-avatar"
                    />
                    <span className="scheduling-sidebar-filter-label scheduling-sidebar-filter-label--coach">
                      {c.name}
                    </span>
                  </label>
                </div>
              </li>
            ))}
          </ul>
        </section>
      )}

      <button
        type="button"
        className="scheduling-sidebar-filter-reset"
        onClick={resetFilters}
      >
        Reset
      </button>
    </div>
  );
};

export default SchedulingSidebarFilters;
